import React from 'react';
import {createBrowserRouter} from 'react-router-dom';

import {BackgroundTaskContextProvider} from 'src/contexts/background-task-context';
import {BroadcastContextProvider} from 'src/contexts/brodcast-context';
import {ConfirmationContextProvider} from 'src/contexts/confirmation-context';
import {ExternalLinksContextProvider} from 'src/contexts/external-links-context';
import {LocaleContextProvider} from 'src/contexts/locale-context';
import {MessageContextProvider} from 'src/contexts/message-context';
import {StatsigContextProvider} from 'src/contexts/statsig-contex';
import {Authentication} from 'src/modules/authentication';
import {Authorization} from 'src/modules/authorization';
import {
    AddAttendeesResult,
    AssignAccountEntitlementsResult,
    AssignAccountsEntitlementsResult,
    AssignProductAccountEntitlementsResult,
    AssignProductSeatResult,
    AssignProductUserEntitlementsResult,
    AssignUserEntitlementsResult,
    AssignUsersEntitlementsResult,
    DischargeAccountsEntitlementsResult,
    DischargeUsersEntitlementsResult,
    ImportUserResult,
    LicenseAccessModuleDisableResult,
    LicenseAccessModuleEnableResult,
    RemoveAccountTeamMemberResult,
    RemoveAttendeesResult,
    SendWelcomeEmailResult,
    SubscribeToLcdCreditAnalysisResult,
    UnassignAccountEntitlementsResult,
    UnassignProductAccountEntitlementsResult,
    UnassignProductSeatResult,
    UnassignProductUserEntitlementsResult,
    UnassignUserEntitlementsResult,
    UnsubscribeFromLcdCreditAnalysisResult,
    UpdateAccountStatusResult,
    UpdateAccountTeamMemberResult,
    UpdateAdminRoleResult,
    UpdateCrmIdsResult,
    UpdateDeviceRegistrationResult,
    UpdateMfaResult,
    UpdateUserAccountResult,
    UpdateUserGroupResult,
    UpdateUserNewsletterResult,
    UpdateUserStateResult,
} from 'src/modules/bulk-update';
import {Main} from 'src/modules/main';

import {HorizontalPositionElement, VerticalPositionElement} from '@pb/kit-component-auto-position-box';
import {PushNotification} from '@pb/kit-component-push-notification';
import {GlobalHistoryContextProvider} from '@pb/kit-context-global-history';

export const router = createBrowserRouter([
    {
        path: '*',
        element: (
            <Authentication>
                <Authorization>
                    <GlobalHistoryContextProvider>
                        <StatsigContextProvider>
                            <ExternalLinksContextProvider>
                                <LocaleContextProvider>
                                    <PushNotification anchorOrigin={{
                                        horizontal: HorizontalPositionElement.LEFT,
                                        vertical: VerticalPositionElement.BOTTOM,
                                    }}>
                                        <BroadcastContextProvider>
                                            <MessageContextProvider>
                                                <ConfirmationContextProvider>
                                                    <BackgroundTaskContextProvider>
                                                        <Main/>
                                                        <UpdateMfaResult/>
                                                        <ImportUserResult/>
                                                        <AddAttendeesResult/>
                                                        <UpdateCrmIdsResult/>
                                                        <UpdateUserGroupResult/>
                                                        <AssignProductSeatResult/>
                                                        <UnassignProductSeatResult/>
                                                        <RemoveAttendeesResult/>
                                                        <UpdateUserStateResult/>
                                                        <UpdateAdminRoleResult/>
                                                        <SendWelcomeEmailResult/>
                                                        <UpdateUserAccountResult/>
                                                        <UpdateAccountStatusResult/>
                                                        <UpdateUserNewsletterResult/>
                                                        <AssignUserEntitlementsResult/>
                                                        <RemoveAccountTeamMemberResult/>
                                                        <UpdateAccountTeamMemberResult/>
                                                        <UpdateDeviceRegistrationResult/>
                                                        <UnassignUserEntitlementsResult/>
                                                        <AssignAccountEntitlementsResult/>
                                                        <LicenseAccessModuleEnableResult/>
                                                        <LicenseAccessModuleDisableResult/>
                                                        <UnassignAccountEntitlementsResult/>
                                                        <SubscribeToLcdCreditAnalysisResult/>
                                                        <UnsubscribeFromLcdCreditAnalysisResult/>
                                                        <AssignAccountsEntitlementsResult/>
                                                        <DischargeAccountsEntitlementsResult/>
                                                        <AssignUsersEntitlementsResult/>
                                                        <DischargeUsersEntitlementsResult/>
                                                        <AssignProductAccountEntitlementsResult/>
                                                        <UnassignProductAccountEntitlementsResult/>
                                                        <AssignProductUserEntitlementsResult/>
                                                        <UnassignProductUserEntitlementsResult/>
                                                    </BackgroundTaskContextProvider>
                                                </ConfirmationContextProvider>
                                            </MessageContextProvider>
                                        </BroadcastContextProvider>
                                    </PushNotification>
                                </LocaleContextProvider>
                            </ExternalLinksContextProvider>
                        </StatsigContextProvider>
                    </GlobalHistoryContextProvider>
                </Authorization>
            </Authentication>
        ),
    },
]);
